import { Box } from '@mui/material'
import {
  ChipData,
  FeatureCard,
  LinkClick,
  SectionHeader,
  SectionHeaderData,
  SectionWrapper,
} from '@components/common'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

export type PortfolioSectionData = {
  sectionHeaderData?: SectionHeaderData
  chipsData?: ChipData[]
  darkBg?: boolean
}

type PortfolioSectionProps = PortfolioSectionData & {
  darkBg?: boolean
  showDivider?: 'bottom' | 'top' | 'both' | 'none'
  alternateSectionBg?: boolean
}

export function PortfolioSection({
  sectionHeaderData,
  chipsData,
  darkBg = false,
  showDivider,
  alternateSectionBg = false,
}: PortfolioSectionProps) {
  const styles = getStyles(defaultStyles)

  return (
    <SectionWrapper
      flexCol={{ xs: '20px', md: '40px' }}
      showDivider={showDivider}
      alternateBg={darkBg}
      alternateSectionBg={alternateSectionBg}
    >
      {sectionHeaderData && (
        <SectionHeader {...sectionHeaderData} darkBg={darkBg} />
      )}

      {!!chipsData?.length && (
        <Box {...styles('cardWrapper')}>
          {chipsData.map(({ label, link, iconData }) => {
            return (
              <LinkClick
                key={label}
                link={link}
                {...styles('featureCardWrapper')}
              >
                <FeatureCard
                  title={label}
                  iconData={iconData}
                  dark={darkBg}
                  csx={{
                    wrapper: styles('featureCardWrapperLink').sx,
                    contentContainer: {
                      width: '100%',
                      alignItems: 'center',
                    },
                  }}
                  iconImageSx={{
                    backgroundColor: darkBg
                      ? 'custom.darkIconBg'
                      : 'background.default',
                  }}
                />
              </LinkClick>
            )
          })}
        </Box>
      )}
    </SectionWrapper>
  )
}
